import { BE_CONFIG } from "./be";
import { NL_CONFIG } from "./nl";
import type { CountryConfig } from "./types";

// Build-time selectie: VITE_COUNTRY mag als shell-/dashboard-variabele of in
// .env.local gezet worden; vite.config.ts leest via Vite's loadEnv() dezelfde
// waarde, dus deze keuze blijft in sync met de config die het HTML-bestand stempelt.
export const COUNTRY_CONFIG: CountryConfig =
  import.meta.env.VITE_COUNTRY === "be" ? BE_CONFIG : NL_CONFIG;

export type {
  AlternateSite,
  CountryConfig,
  ExpectedPriceSource,
  Region,
} from "./types";
export {
  cheapestProviderId,
  providerRegions,
  providersForRegion,
  resolveProvider,
  resolveSelectedProviderId,
} from "./regions";
